import { render, staticRenderFns } from "./ProjectOverview.vue?vue&type=template&id=a222bcf4&scoped=true"
import script from "./ProjectOverview.vue?vue&type=script&lang=js"
export * from "./ProjectOverview.vue?vue&type=script&lang=js"
import style0 from "./ProjectOverview.vue?vue&type=style&index=0&id=a222bcf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a222bcf4",
  null
  
)

export default component.exports